import { makeAutoObservable, runInAction } from "mobx";
import { Store, IUserFeedbackStore, AllUserFeedbackData } from "../global/types";
import { getAllMotiTagsData, getAllUserFeedbackData } from "../api/user.action"

class UserFeedbackStore implements IUserFeedbackStore {
    rootStore: Store;
    allUserFeedbackData: AllUserFeedbackData[] = [];
    userFeedbackData: AllUserFeedbackData | null = null;
    error: string | null = null;
    loading: boolean = false;
    page: number = 1;
    searchTerm: string = '';
    limit: number = 10;
    totalItems: number = 0;
    totalPages: number = 0;
    customerId: string = '';

    constructor(rootStore: Store) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    setLoading = (loading: boolean) => {
        this.loading = loading;
    }

    fetchAllUserFeedbackData = async (
        action: 'change_page' | 'search' | 'change_limit' | 'change_filter' | '',
        page: number,
        searchTerm: string,
        limit: number
    ) => {
        this.setLoading(true);
        try {
            runInAction(() => {
                switch (action) {
                    case 'change_page':
                        this.page = page;
                        break;
                    case 'search':
                        this.searchTerm = searchTerm;
                        this.page = 1;
                        break;
                    case 'change_limit':
                        this.limit = limit
                        this.page = 1
                        break;
                    default:
                        break;
                }
            })
            const data = {
                page: this.page,
                limit: this.limit,
                search: this.searchTerm?.trim()
            }
            const response = await getAllUserFeedbackData(data);
            runInAction(() => {
                this.allUserFeedbackData = response.data?.feedbacks || [];
                this.totalItems = response.data?.totalItems;
                this.totalPages = response.data?.totalPages;
            })
        } catch (error: unknown) {
            this.rootStore.authStore.handleUnauthorized(error);
        } finally {
            this.setLoading(false);
        }
    }

    resetUserFeedbackPageDataStates = () => {
        runInAction(() => {
            this.allUserFeedbackData = [];
            this.userFeedbackData = null;
            this.error = null;
            this.loading = false;
            this.page = 1;
            this.searchTerm = '';
            this.limit = 10;
            this.totalItems = 0;
            this.totalPages = 0;
        })
    }
}

export default UserFeedbackStore;
